import * as React from "react";
import { MessageCard, MessageCardSeverity } from "azure-devops-ui/MessageCard";
import { IButtonProps } from "azure-devops-ui/Button";

export default class ErrorExample extends React.Component {
    private buttonProps: IButtonProps[] = [
        {
            text: "Open docs",
            onClick: () => {
                alert("Docs will be opened");
            }
        },
        {
            text: "Manage services",
            onClick: () => {
                alert("Services will be managed");
            }
        }
    ];

    public render(): JSX.Element {
        const message: string = "We couldn't load the details for this subscription.";

        return (
            <MessageCard
                buttonProps={this.buttonProps}
                className="flex-self-stretch"
                severity={MessageCardSeverity.Error}
            >
                {message}
            </MessageCard>
        );
    }
}
